import { useApp } from '@libs/core';
import React, { useEffect, useRef } from 'react';
import { Modal } from '../Modal/Modal';

type TModalWithTimerProps = {
    children?: React.ReactNode;
};

const ModalWithTimer = ({ children }: TModalWithTimerProps) => {
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const { setModal } = useApp();

    useEffect(() => {
        const closeModal = () => {
            setModal?.(null);
        };
        timeoutRef.current = setTimeout(closeModal, 2000);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [setModal]);
    return (
        <Modal isCanCloseModal={false} isVerticalCentered noTopPadding>
            {children}
        </Modal>
    );
};

export { ModalWithTimer };
